import React, { Component } from 'react';
import Editbox from '../../Part_Sample/Editbox';
import Top_Bar from '../../Part_Sample/Top_Bar';
import Icon_Carousel from '../../Part_Sample/Icon_Carousel';
import Display_Actions from '../../Display_Actions/Display_Actions';
import { getSceneIconList, isEmpty } from '../../Common/Common';

export default class Add_Edit_Scene extends Component {
	constructor(props) {
		super(props);

		this.lastClickTime = false;

		this.scenes = this.props.param.scenes;
		this.scene_detail = {};
		let scene_name = '';
		let selected_icon = 'Backhome.png';

		if (this.props.param.scene_detail) {
			// If navigate from Add_Edit_Scene_Details after modifying
			// Used for adding new scenes because new scene do not have scene_id
			this.scene_detail = this.props.param.scene_detail;
			scene_name = this.scene_detail.name;
			selected_icon = this.scene_detail.icon;
		} else if (this.props.param.scene_id != null) {
			this.scene_detail = JSON.parse(JSON.stringify(this.props.param.scenes[this.props.param.scene_id]));
			scene_name = this.scene_detail.name;
			selected_icon = this.scene_detail.icon;
		} else {
			this.scene_detail.action = {};
		}

		let icon_list = getSceneIconList();
		for (let i in icon_list) {
			if (icon_list[i].key == selected_icon) {
				icon_list[i].is_selected = true;
				break;
			}
		}

		this.state = {
			scene_name: scene_name,
			icon_list: icon_list,
		}
	}

	preventMultipleTaps = () => {
		if(this.lastClickTime == false) {		//Check if it is first click, allow
			this.lastClickTime = true;
			return true;
		} else {
			return false;
		}
	}

	handlePrevious = () => {
		this.props.content_handler('Scene_Settings', { scenes: this.scenes, from: this.props.param.from });
	}

	handleChangeSceneName = (val) => {
		this.setState({ scene_name: val })
	}

	handleAddSceneCommand = () => {
		let selected_icon = ''
		for (let i in this.state.icon_list) {
			if (this.state.icon_list[i].is_selected) {
				selected_icon = this.state.icon_list[i].key;
				break;
			}
		}
		this.scene_detail.icon = selected_icon;
		this.scene_detail.name = this.state.scene_name;
		this.props.content_handler('Add_Edit_Scene_Command', { scene_detail: this.scene_detail, scene_id: this.props.param.scene_id, scenes: this.props.param.scenes, from: this.props.param.from })
	}

	handleEditSceneCommand = (point_id) => {
		let selected_icon = ''
		for (let i in this.state.icon_list) {
			if (this.state.icon_list[i].is_selected) {
				selected_icon = this.state.icon_list[i].key;
				break;
			}
		}
		this.scene_detail.icon = selected_icon;
		this.scene_detail.name = this.state.scene_name;
		this.props.content_handler('Add_Edit_Scene_Command', { point_id: point_id, scene_detail: this.scene_detail, scene_id: this.props.param.scene_id, scenes: this.props.param.scenes, from: this.props.param.from })
	}

	handleSelectIcon = (key) => {
		let icon_list = this.state.icon_list;
		for (let i in icon_list) {
			if (icon_list[i].key == key) {
				icon_list[i].is_selected = true;
			} else {
				icon_list[i].is_selected = false;
			}
		}

		this.setState({ icon_list: icon_list })
	}

	handleRegister = () => {
		if (!this.preventMultipleTaps()) return;
		window.app.showLoading();

		let selected_icon = ''
		for (let i in this.state.icon_list) {
			if (this.state.icon_list[i].is_selected) {
				selected_icon = this.state.icon_list[i].key;
				break;
			}
		}

		//Delete scene_detail if point id does not exist.
		for (var key in this.scene_detail.action) {
			if(!window.app.state.point_list.hasOwnProperty(key)) {
				delete this.scene_detail.action[key]
			}
		}

		if (this.state.scene_name == '') {
			window.app.hideLoading();
			this.lastClickTime = false;
			window.app.showToast(this.props.receiver.getString('no_name'), 3000);
			return;
		} else if (isEmpty(this.scene_detail.action)) {
			window.app.hideLoading();
			this.lastClickTime = false;
			window.app.showToast(this.props.receiver.getString('no_action'), 3000);
			return;
		} else if (selected_icon == '') {
			window.app.hideLoading();
			this.lastClickTime = false;
			window.app.showToast(this.props.receiver.getString('sel_icon'), 3000);
			return;
		}

		this.scene_detail.name = this.state.scene_name;
		this.scene_detail.icon = selected_icon;

		if (this.props.param.scene_id == null) {
			this.props.receiver.addScene(this.scene_detail);
		} else {
			let scene = {};
			scene[this.props.param.scene_id] = this.scene_detail;
			this.props.receiver.modifyScene(scene);
		}
	}

	handleDelete = () => {
		if (!this.preventMultipleTaps()) return;
		window.app.showLoading();

		this.props.receiver.deleteScene(this.props.param.scene_id);
	}

	rcvAddScene = (response) => {
		if (response.result != 'NG') {
			this.props.receiver.stored_params.from = this.props.param.from;
			this.props.receiver.next_component = 'Scene_Settings';
			this.props.receiver.getScene();
		} else {
			window.app.hideLoading();
			this.lastClickTime = false;
			window.app.showToast(this.props.receiver.getString('set_fail'), 3000);
		}
	}

	rcvModifyScene = (response) => {
		if (response.result == 'OK') {
			this.props.receiver.stored_params.from = this.props.param.from;
			this.props.receiver.next_component = 'Scene_Settings';
			this.props.receiver.getScene();
		} else {
			window.app.hideLoading();
			this.lastClickTime = false;
			window.app.showToast(this.props.receiver.getString('set_fail'), 3000);
		}
	}

	rcvDeleteScene = (response) => {
		if (response.result == 'OK') {
			this.props.receiver.stored_params.from = this.props.param.from;
			this.props.receiver.next_component = 'Scene_Settings';
			this.props.receiver.getScene();
		} else {
			window.app.hideLoading();
			this.lastClickTime = false;
			window.app.showToast(this.props.receiver.getString('del_fail'), 3000);
		}
	}

	render() {
		let style = {
			textAlign: 'center',
			width: '100%',
		}

		let main_content_style = {
			position: 'fixed',
			top: 0,
			width: '100%',
			height: this.props.height,
		}

		return (
			<div style={style}>
				<div id='main_content' style={main_content_style} className='slideInDown noScrollBar'>
					<Top_Bar
						width={this.props.width}
						title={this.props.param.scene_id != null ? this.props.receiver.getString('edit_scene') : this.props.receiver.getString('add_scene')}
						left_button_type={'back'}
						handleLeftButton={this.handlePrevious}
					/>
					<div style={{ overflow: 'auto', height: this.props.height - 140, paddingbottom: 60 }}>
						<div style={{ textAlign: 'center', marginLeft: 20 }}>
							<Editbox id='scene_name' style={{ width: this.props.width - 40 }} placeholder={this.props.receiver.getString('name')} inputType='text' onChange={(event) => this.handleChangeSceneName(event.target.value)} value={this.state.scene_name} />
						</div>
						<div style={{ marginTop: 20 }}>
							<Icon_Carousel id={'scene_icons'} width={this.props.width} icon_list={this.state.icon_list} handleSelectIcon={this.handleSelectIcon} />
						</div>
						<div style={{ marginTop: 20, textAlign: 'left', marginLeft: 20 }}>
							<span className='title'> {this.props.receiver.getString('scene_command')}</span>
						</div>
						<div style={{ marginLeft: 20 }}>
							{Object.keys(this.scene_detail.action).map((point_id) => {
								let actions = this.scene_detail.action[point_id];
								let point_info = window.app.state.point_list[point_id];
								// If point info is empty, do not display
								// Adjust the width % and background color
								if (point_info != null) {
									return (
										<div style={{ textAlign: 'left', marginTop: 10, width: this.props.width - 40, backgroundColor: '#f1f1f1', display: 'flex', justifyContent: 'center', alignItems: 'center', borderRadius: 10, minHeight: 50 }} onClick={() => this.handleEditSceneCommand(point_id)}>
											<div style={{ display: 'inline-block', width: '50%' }}>
												<div style={{ marginLeft: 10 }}>
													<span> {point_info.name} </span>
												</div>
											</div>
											<Display_Actions style={{ width: '50%', textAlign: 'right' }} point_info={point_info} actions={actions} receiver={this.props.receiver} />
										</div>
									)
								} else {
									return null;
								}
							})}
						</div>
						<div id='add_scene_command' onClick={this.handleAddSceneCommand} style={{ marginTop: 20, padding: 5, width: this.props.width - 80, marginLeft: 'auto', marginRight: 'auto', minWidth: 30, verticalAlign: 'top', textAlign: 'center', cursor: 'pointer', border: '1px solid ' + this.props.colours.appBlue }}>
							<span className='footnote'>{this.props.receiver.getString('add_scene_com_instr')}</span>
						</div>
					</div>
				</div>
			</div>
		)
	}
}